module.exports = web3dPluginCustomObject;